var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.95L7 12.8L12 14.95V2H2V14.95ZM1.4 17.4C1.06667 17.5333 0.75 17.504 0.45 17.312C0.15 17.12 0 16.8413 0 16.476V2C0 1.45 0.196 0.979002 0.588 0.587002C0.98 0.195002 1.45067 -0.000664969 2 1.69779e-06H12C12.55 1.69779e-06 13.021 0.196002 13.413 0.588002C13.805 0.980002 14.0007 1.45067 14 2V16.475C14 16.8417 13.85 17.121 13.55 17.313C13.25 17.505 12.9333 17.534 12.6 17.4L7 15L1.4 17.4Z",
    fill: "#D2D5DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOutline);
export default __webpack_public_path__ + "static/media/service-outline.a80692abb63b3f0bfd112d3c4da615cf.svg";
export { ForwardRef as ReactComponent };